import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

export default function FarmingtonPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="min-h-screen bg-white">
        {/* Schema Markup */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebPage",
                "@id": "https://valvebuyers.com/farmington",
                "url": "https://valvebuyers.com/farmington",
                "name": "We Buy Valves Farmington NM | Surplus Industrial Equipment Buyer",
                "description": "Leading buyer of surplus valves and industrial equipment in Farmington, NM. Serving San Juan Basin gas processing facilities with fast response and competitive pricing.",
                "breadcrumb": {
                  "@type": "BreadcrumbList",
                  "itemListElement": [
                    {
                      "@type": "ListItem",
                      "position": 1,
                      "name": "Home",
                      "item": "https://valvebuyers.com"
                    },
                    {
                      "@type": "ListItem",
                      "position": 2,
                      "name": "New Mexico",
                      "item": "https://valvebuyers.com/new-mexico"
                    },
                    {
                      "@type": "ListItem",
                      "position": 3,
                      "name": "Farmington",
                      "item": "https://valvebuyers.com/farmington"
                    }
                  ]
                }
              },
              {
                "@type": "LocalBusiness",
                "@id": "https://valvebuyers.com/farmington#business",
                "name": "Valve Buyers - Farmington NM",
                "image": "https://valvebuyers.com/logo.png",
                "description": "Professional buyer of surplus valves and industrial equipment in Farmington, NM. Specializing in gas processing, compression, and pipeline equipment from San Juan Basin facilities.",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Farmington",
                  "addressRegion": "NM",
                  "postalCode": "87401",
                  "addressCountry": "US"
                },
                "geo": {
                  "@type": "GeoCoordinates",
                  "latitude": 36.7280,
                  "longitude": -108.2187
                },
                "url": "https://valvebuyers.com/farmington",
                "telephone": "+1-555-VALVES",
                "priceRange": "$$$",
                "openingHoursSpecification": [
                  {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                    "opens": "08:00",
                    "closes": "17:00"
                  },
                  {
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": "Saturday",
                    "opens": "09:00",
                    "closes": "14:00"
                  }
                ],
                "areaServed": [
                  {
                    "@type": "City",
                    "name": "Farmington",
                    "containedIn": {
                      "@type": "State",
                      "name": "New Mexico"
                    }
                  },
                  {
                    "@type": "City",
                    "name": "Aztec",
                    "containedIn": {
                      "@type": "State",
                      "name": "New Mexico"
                    }
                  },
                  {
                    "@type": "City",
                    "name": "Bloomfield",
                    "containedIn": {
                      "@type": "State",
                      "name": "New Mexico"
                    }
                  },
                  {
                    "@type": "City",
                    "name": "Shiprock",
                    "containedIn": {
                      "@type": "State",
                      "name": "New Mexico"
                    }
                  },
                  {
                    "@type": "City",
                    "name": "Kirtland",
                    "containedIn": {
                      "@type": "State",
                      "name": "New Mexico"
                    }
                  },
                  {
                    "@type": "City",
                    "name": "Durango",
                    "containedIn": {
                      "@type": "State",
                      "name": "Colorado"
                    }
                  }
                ],
                "hasOfferCatalog": {
                  "@type": "OfferCatalog",
                  "name": "Surplus Industrial Equipment Buying Services",
                  "itemListElement": [
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Fisher Control Valve Acquisition",
                        "description": "Purchase of Fisher control valves including DVC6200, 657, 667, and Fieldvue digital positioners from gas processing facilities"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Gate & Globe Valve Purchasing",
                        "description": "Acquisition of gate valves, globe valves, and check valves from compression stations and pipeline facilities"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Ball Valve & Specialty Valve Buying",
                        "description": "Purchase of ball valves, butterfly valves, plug valves, and specialty valves from San Juan Basin operations"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Instrumentation Equipment Acquisition",
                        "description": "Buying pressure transmitters, flow meters, temperature sensors, and control panels from gas processing plants"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Compression Equipment Purchasing",
                        "description": "Acquisition of compressor valves, actuators, and related equipment from compression facilities"
                      }
                    },
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Emergency Equipment Buyout",
                        "description": "Rapid response purchasing for facility closures, upgrades, and turnaround projects in Farmington area"
                      }
                    }
                  ]
                }
              },
              {
                "@type": "Service",
                "@id": "https://valvebuyers.com/farmington#service",
                "serviceType": "Industrial Equipment Acquisition",
                "provider": {
                  "@id": "https://valvebuyers.com/farmington#business"
                },
                "areaServed": [
                  {
                    "@type": "City",
                    "name": "Farmington",
                    "containedIn": "New Mexico"
                  },
                  {
                    "@type": "City",
                    "name": "Aztec",
                    "containedIn": "New Mexico"
                  },
                  {
                    "@type": "City",
                    "name": "Bloomfield",
                    "containedIn": "New Mexico"
                  },
                  {
                    "@type": "City",
                    "name": "Shiprock",
                    "containedIn": "New Mexico"
                  },
                  {
                    "@type": "City",
                    "name": "Kirtland",
                    "containedIn": "New Mexico"
                  },
                  {
                    "@type": "City",
                    "name": "Durango",
                    "containedIn": "Colorado"
                  }
                ],
                "description": "Professional acquisition of surplus valves and industrial equipment from gas processing facilities, compression stations, and pipeline operations throughout the San Juan Basin region."
              },
              {
                "@type": "FAQPage",
                "@id": "https://valvebuyers.com/farmington#faq",
                "mainEntity": [
                  {
                    "@type": "Question",
                    "name": "What types of valves do you buy in Farmington, NM?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "We purchase all types of industrial valves in Farmington including Fisher control valves (DVC6200, 657, 667, Fieldvue), gate valves, globe valves, ball valves, check valves, butterfly valves, plug valves, and specialty valves. We specialize in equipment from gas processing facilities, compression stations, and pipeline operations throughout the San Juan Basin."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "How quickly can you respond to Farmington facilities?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "We provide 3-5 hour response time for Farmington and surrounding San Juan Basin facilities. Our team is familiar with local gas processing plants, compression stations, and pipeline operations, enabling rapid equipment assessment and competitive offers for your surplus equipment."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Do you buy equipment from gas processing facilities in Farmington?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes, we specialize in purchasing surplus equipment from Farmington's gas processing facilities including Williams Four Corners, Enterprise Products, and other San Juan Basin operations. We buy control valves, instrumentation, compression equipment, and all related industrial equipment from gas processing plants."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "What brands of control valves do you purchase in Farmington?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "We purchase all major control valve brands in Farmington including Fisher (Emerson), Masoneilan, Crosby, Anderson Greenwood, Cashco, Mokveld, and Flowserve. We specialize in Fisher DVC6200, 657, 667 series, and Fieldvue digital positioners commonly used in San Juan Basin gas processing facilities."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Do you buy instrumentation equipment from Farmington facilities?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Yes, we purchase all types of instrumentation equipment from Farmington facilities including Rosemount pressure transmitters, flow meters, temperature sensors, level transmitters, control panels, PLCs, and analytical equipment. We buy from gas processing plants, compression stations, and pipeline operations throughout the San Juan Basin."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "What is the process for selling valves in Farmington, NM?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Selling valves in Farmington is simple: 1) Contact us with your equipment list and photos, 2) We provide a competitive quote within 24 hours, 3) Upon acceptance, we arrange pickup from your Farmington facility within 3-5 hours, 4) Payment is processed immediately upon equipment verification. We handle all logistics and documentation for your convenience."
                    }
                  }
                ]
              }
            ]
          })}
        </script>

        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-24">
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
          <div className="max-w-7xl mx-auto px-6 relative z-10">
            <div className="max-w-4xl">
              <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
                We Buy Valves Farmington
              </h1>
              <p className="text-xl md:text-2xl text-slate-200 mb-8 leading-relaxed">
                Leading buyer of surplus valves and industrial equipment in Farmington, NM. Serving San Juan Basin gas processing facilities, compression stations, and pipeline operations with fast response and competitive pricing.
              </p>
              <div className="flex flex-wrap gap-4">
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold transition-all whitespace-nowrap"
                >
                  <i className="ri-phone-line text-xl"></i>
                  Get Quote Today
                </Link>
                <Link
                  to="/what-we-buy"
                  className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold transition-all whitespace-nowrap border border-white/20"
                >
                  <i className="ri-list-check text-xl"></i>
                  Equipment We Buy
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-16 bg-slate-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">3-5 hrs</div>
                <div className="text-slate-600 font-medium">Response Time</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">150+</div>
                <div className="text-slate-600 font-medium">Gas Processing Sites</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">50+</div>
                <div className="text-slate-600 font-medium">Compression Stations</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-teal-600 mb-2">24/7</div>
                <div className="text-slate-600 font-medium">Emergency Service</div>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid lg:grid-cols-2 gap-16 items-start">
              <div>
                <h2 className="text-4xl font-bold text-slate-900 mb-6">
                  Farmington Gas Processing Equipment Buyer
                </h2>
                <div className="prose prose-lg max-w-none text-slate-600 space-y-4">
                  <p>
                    As the leading buyer of surplus valves and industrial equipment in Farmington, New Mexico, we specialize in purchasing equipment from San Juan Basin gas processing facilities, compression stations, and pipeline operations. Our team provides rapid response and competitive pricing for all types of industrial equipment.
                  </p>
                  <p>
                    Farmington is the heart of the San Juan Basin, one of the most productive natural gas regions in the United States. We serve major facilities including Williams Four Corners Gas Processing Plant, Enterprise Products Partners facilities, and numerous compression stations throughout the region.
                  </p>
                  <p>
                    Our expertise in gas processing equipment, compression systems, and pipeline infrastructure ensures you receive maximum value for your surplus equipment. We understand the unique requirements of San Juan Basin operations and provide tailored solutions for facility upgrades, turnarounds, and closures.
                  </p>
                </div>
              </div>

              <div className="bg-slate-50 rounded-xl p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-6">
                  <i className="ri-building-line text-teal-600 mr-3"></i>
                  Farmington Facilities We Serve
                </h3>
                <div className="space-y-4">
                  <div className="bg-white rounded-lg p-5 border border-slate-200">
                    <div className="font-semibold text-slate-900 mb-2">Williams Four Corners</div>
                    <div className="text-slate-600 text-sm">Gas Processing Plant - 1.2 BCF/day capacity</div>
                  </div>
                  <div className="bg-white rounded-lg p-5 border border-slate-200">
                    <div className="font-semibold text-slate-900 mb-2">Enterprise Products Partners</div>
                    <div className="text-slate-600 text-sm">Gas Processing & Pipeline Operations</div>
                  </div>
                  <div className="bg-white rounded-lg p-5 border border-slate-200">
                    <div className="font-semibold text-slate-900 mb-2">San Juan Basin Compression</div>
                    <div className="text-slate-600 text-sm">50+ Compression Stations</div>
                  </div>
                  <div className="bg-white rounded-lg p-5 border border-slate-200">
                    <div className="font-semibold text-slate-900 mb-2">Bloomfield Gas Plants</div>
                    <div className="text-slate-600 text-sm">Multiple Processing Facilities</div>
                  </div>
                  <div className="bg-white rounded-lg p-5 border border-slate-200">
                    <div className="font-semibold text-slate-900 mb-2">Aztec Area Operations</div>
                    <div className="text-slate-600 text-sm">Gas Gathering & Processing</div>
                  </div>
                  <div className="bg-white rounded-lg p-5 border border-slate-200">
                    <div className="font-semibold text-slate-900 mb-2">Pipeline Infrastructure</div>
                    <div className="text-slate-600 text-sm">Regional Pipeline Systems</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Equipment Categories */}
        <section className="py-20 bg-slate-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-slate-900 mb-4">
                Sell Valves Farmington NM
              </h2>
              <p className="text-xl text-slate-600 max-w-3xl mx-auto">
                We purchase all types of industrial equipment from Farmington gas processing facilities, compression stations, and pipeline operations
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center">
                    <i className="ri-settings-3-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900">Fisher Control Valves</h3>
                </div>
                <ul className="space-y-3 text-slate-600">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Fisher DVC6200:</strong> Digital valve controllers with HART protocol</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Fisher 657/667:</strong> Size 30-70 diaphragm actuators</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Fieldvue Digital:</strong> DVC6200, DVC6000 series positioners</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Fisher ED/EZ Series:</strong> Easy-e and sliding stem valves</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Masoneilan Valves:</strong> 35-series and Camflex II control valves</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center">
                    <i className="ri-door-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900">Gate & Globe Valves</h3>
                </div>
                <ul className="space-y-3 text-slate-600">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Gate Valves:</strong> 2"-24" Class 150-2500 carbon & stainless steel</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Globe Valves:</strong> Angle, Y-pattern, and conventional globe valves</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Check Valves:</strong> Swing, lift, and dual-plate check valves</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>API 6D Valves:</strong> Pipeline specification gate and ball valves</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>High Pressure:</strong> Class 600-2500 valves for compression service</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center">
                    <i className="ri-circle-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900">Ball & Specialty Valves</h3>
                </div>
                <ul className="space-y-3 text-slate-600">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Ball Valves:</strong> Floating, trunnion, and metal-seated ball valves</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Butterfly Valves:</strong> High-performance and triple-offset designs</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Plug Valves:</strong> Lubricated and non-lubricated plug valves</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Safety Relief:</strong> Crosby, Anderson Greenwood, and Consolidated valves</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Actuated Valves:</strong> Pneumatic, electric, and hydraulic actuators</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center">
                    <i className="ri-dashboard-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900">Instrumentation</h3>
                </div>
                <ul className="space-y-3 text-slate-600">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Pressure Transmitters:</strong> Rosemount 3051, 2088, and 1151 series</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Flow Meters:</strong> Orifice, turbine, Coriolis, and ultrasonic meters</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Temperature Sensors:</strong> RTDs, thermocouples, and transmitters</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Control Panels:</strong> DCS systems, PLCs, and HMI equipment</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                    <span><strong>Analytical Equipment:</strong> Gas chromatographs and analyzers</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Related Markets */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-4xl font-bold text-slate-900 mb-12 text-center">
              Related San Juan Basin Markets
            </h2>
            <div className="grid md:grid-cols-3 gap-6">
              <Link
                to="/aztec"
                className="group bg-slate-50 hover:bg-teal-50 rounded-xl p-8 transition-all border border-slate-200 hover:border-teal-200"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center group-hover:bg-teal-200 transition-colors">
                    <i className="ri-map-pin-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900">Aztec, NM</h3>
                </div>
                <p className="text-slate-600">Gas gathering and processing facilities in San Juan County</p>
              </Link>

              <Link
                to="/bloomfield"
                className="group bg-slate-50 hover:bg-teal-50 rounded-xl p-8 transition-all border border-slate-200 hover:border-teal-200"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center group-hover:bg-teal-200 transition-colors">
                    <i className="ri-map-pin-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900">Bloomfield, NM</h3>
                </div>
                <p className="text-slate-600">Multiple gas processing plants and compression stations</p>
              </Link>

              <Link
                to="/durango"
                className="group bg-slate-50 hover:bg-teal-50 rounded-xl p-8 transition-all border border-slate-200 hover:border-teal-200"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center group-hover:bg-teal-200 transition-colors">
                    <i className="ri-map-pin-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900">Durango, CO</h3>
                </div>
                <p className="text-slate-600">Northern San Juan Basin operations and pipeline infrastructure</p>
              </Link>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-teal-600 to-teal-700 text-white">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-4xl font-bold mb-6">
              Farmington Equipment Buyer
            </h2>
            <p className="text-xl text-teal-50 mb-8 leading-relaxed">
              Get competitive pricing for your surplus valves and industrial equipment. We provide 3-5 hour response time for Farmington and San Juan Basin facilities with immediate payment upon equipment verification.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-white text-teal-600 hover:bg-slate-50 px-8 py-4 rounded-lg font-semibold transition-all whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl"></i>
                Request Quote
              </Link>
              <Link
                to="/how-it-works"
                className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-400 text-white px-8 py-4 rounded-lg font-semibold transition-all whitespace-nowrap"
              >
                <i className="ri-information-line text-xl"></i>
                How It Works
              </Link>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-20 bg-slate-50">
          <div className="max-w-4xl mx-auto px-6">
            <h2 className="text-4xl font-bold text-slate-900 mb-12 text-center">
              Farmington Valve Buyers FAQ
            </h2>
            <div className="space-y-6">
              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  What types of valves do you buy in Farmington, NM?
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  We purchase all types of industrial valves in Farmington including Fisher control valves (DVC6200, 657, 667, Fieldvue), gate valves, globe valves, ball valves, check valves, butterfly valves, plug valves, and specialty valves. We specialize in equipment from gas processing facilities, compression stations, and pipeline operations throughout the San Juan Basin.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  How quickly can you respond to Farmington facilities?
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  We provide 3-5 hour response time for Farmington and surrounding San Juan Basin facilities. Our team is familiar with local gas processing plants, compression stations, and pipeline operations, enabling rapid equipment assessment and competitive offers for your surplus equipment.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  Do you buy equipment from gas processing facilities in Farmington?
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  Yes, we specialize in purchasing surplus equipment from Farmington's gas processing facilities including Williams Four Corners, Enterprise Products, and other San Juan Basin operations. We buy control valves, instrumentation, compression equipment, and all related industrial equipment from gas processing plants.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  What brands of control valves do you purchase in Farmington?
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  We purchase all major control valve brands in Farmington including Fisher (Emerson), Masoneilan, Crosby, Anderson Greenwood, Cashco, Mokveld, and Flowserve. We specialize in Fisher DVC6200, 657, 667 series, and Fieldvue digital positioners commonly used in San Juan Basin gas processing facilities.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  Do you buy instrumentation equipment from Farmington facilities?
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  Yes, we purchase all types of instrumentation equipment from Farmington facilities including Rosemount pressure transmitters, flow meters, temperature sensors, level transmitters, control panels, PLCs, and analytical equipment. We buy from gas processing plants, compression stations, and pipeline operations throughout the San Juan Basin.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 border border-slate-200">
                <h3 className="text-xl font-bold text-slate-900 mb-4">
                  What is the process for selling valves in Farmington, NM?
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  Selling valves in Farmington is simple: 1) Contact us with your equipment list and photos, 2) We provide a competitive quote within 24 hours, 3) Upon acceptance, we arrange pickup from your Farmington facility within 3-5 hours, 4) Payment is processed immediately upon equipment verification. We handle all logistics and documentation for your convenience.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}
